import { api } from '../../../../lib/api'

export const DELETE_MERCHANT_REQUEST = 'DELETE_MERCHANT_REQUEST'
export const DELETE_MERCHANT_SUCCESS = 'DELETE_MERCHANT_SUCCESS'
export const DELETE_MERCHANT_FAILED = 'DELETE_MERCHANT_FAILED'

export const deleteMerchant = function (merchantId, onComplete) {
  return function (dispatch) {
    dispatch({
      type: DELETE_MERCHANT_REQUEST
    })
    api.deleteMerchant(merchantId).then(deleteMerchantResponse => {
      dispatch({
        type: DELETE_MERCHANT_SUCCESS,
        payload: deleteMerchantResponse
      })
      onComplete()
    }).catch(error => {
      dispatch({
        type: DELETE_MERCHANT_FAILED,
        error
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/superadmin/merchant/delete-merchant.js